'use client';

export enum PropertyType {
  /* Containers */
  Object = 'Object',
  Array = 'Array',
  /* Basic */
  Select = 'Select',
  MultiSelect = 'MultiSelect',
  Number = 'Number',
  Color = 'Color',
  String = 'String',
  Boolean = 'Boolean',
  Vector2 = 'Vector2',
  Vector3 = 'Vector3',
  Vector4 = 'Vector4',
  Euler = 'Euler',
  /* Custom */
  Asset = 'Asset',
  ActorReference = 'ActorReference',
  ComponentReference = 'ComponentReference',
  Spawnable = 'Spawnable',
  /* Actions */
  Button = 'Button',
  /* Special */
  Error = 'Error',
}
